const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class OpenBordersAgreement extends Pact {
    constructor() {
        super(
            Age.Age1,
            PactNames.OpenBordersAgreement,
            "Both civilizations gain one Military Action. If one attacks the other, the attacking civilization gets a +2 Military bonus.",
            {}
        )
    }
}

module.exports = OpenBordersAgreement;